import { render, staticRenderFns } from "./FeedManagerView.vue?vue&type=template&id=b37026f2&scoped=true&"
import script from "./FeedManagerView.vue?vue&type=script&lang=js&"
export * from "./FeedManagerView.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagerView.vue?vue&type=style&index=0&id=b37026f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37026f2",
  null
  
)

export default component.exports